import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle--down",
  "use": "icon-triangle--down-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 11\" id=\"icon-triangle--down\"><path d=\"M8.771 10.065a1 1 0 0 1-1.542 0L.689 2.136A1 1 0 0 1 1.461.5h13.078a1 1 0 0 1 .772 1.636l-6.54 7.929Z\" fill=\"#F9F4EC\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol